<template>
  <v-row dense>
    <v-col cols="6">
      <v-menu
        ref="fromDateMenu"
        v-model="fromDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="fromDateFormatted"
            :label="fromLabel"
            readonly
            v-bind="attrs"
            v-on="on"
            clearable
            dense
            outlined
            hide-details
            class="date-filter-input"
            @click:clear="clearFromDate"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="fromDateValue"
          @input="fromDateMenu = false"
          :max="toDateValue"
          locale="hr"
          color="primary"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="6">
      <v-menu
        ref="toDateMenu"
        v-model="toDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="toDateFormatted"
            :label="toLabel"
            readonly
            v-bind="attrs"
            v-on="on"
            clearable
            dense
            outlined
            hide-details
            class="date-filter-input"
            @click:clear="clearToDate"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="toDateValue"
          @input="toDateMenu = false"
          :min="fromDateValue"
          locale="hr"
          color="primary"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'DateRangeFilter',
  props: {
    fromDate: {
      type: String,
      default: null
    },
    toDate: {
      type: String,
      default: null
    },
    fromLabel: {
      type: String,
      default: 'Od datuma'
    },
    toLabel: {
      type: String,
      default: 'Do datuma'
    }
  },
  data () {
    return {
      fromDateMenu: false,
      toDateMenu: false
    }
  },
  computed: {
    fromDateValue: {
      get () {
        return this.fromDate
      },
      set (val) {
        this.$emit('update:from-date', val)
      }
    },
    toDateValue: {
      get () {
        return this.toDate
      },
      set (val) {
        this.$emit('update:to-date', val)
      }
    },
    fromDateFormatted: {
      get () {
        return this.fromDateValue ? this.formatDate(this.fromDateValue) : null
      },
      set (val) {
        if (!val) {
          this.fromDateValue = null
        }
      }
    },
    toDateFormatted: {
      get () {
        return this.toDateValue ? this.formatDate(this.toDateValue) : null
      },
      set (val) {
        if (!val) {
          this.toDateValue = null
        }
      }
    }
  },
  methods: {
    formatDate (dateString) {
      if (!dateString) return null
      try {
        return DateTime.fromISO(dateString).setLocale('hr').toFormat('dd.MM.yyyy')
      } catch (error) {
        return dateString
      }
    },
    clearFromDate () {
      this.fromDateValue = null
    },
    clearToDate () {
      this.toDateValue = null
    }
  }
}
</script>

<style scoped>
/* Date filter input styling */
.date-filter-input {
  font-size: 0.9rem !important;
}

.date-filter-input >>> .v-input__control {
  min-height: 40px !important;
}

.date-filter-input >>> .v-text-field__slot {
  min-height: 40px !important;
}

.date-filter-input >>> fieldset {
  border-color: rgba(57, 137, 201, 0.3) !important;
  border-width: 1px !important;
  transition: all 0.15s ease !important;
}

.date-filter-input >>> .v-input--is-focused fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.date-filter-input >>> .v-label {
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

.date-filter-input >>> .v-input__icon--clear {
  color: rgba(57, 137, 201, 0.6) !important;
}

.date-filter-input >>> .v-input__icon--clear:hover {
  color: #3989C9 !important;
}
</style>
